import React from 'react';

const icons = {
    edit: "edit",
    detail: "paste",
    times: "cross",
    paste: "paste",
    copy: "copy",
    check: "check",
    timeArrow: "time-past",
    gear: "gear",
    sync: "sync",
    user: "user",
    headset: "headset",
    bell: "bell",
    cameraMovie: "camera-movie",
    boxesOutline: "boxes-outline",
    truckSide: "truck-side",
    smile: "smile-beam",
    undo: "undo",
    mailbox: "mailbox",
    chevronDown: "chevron-down",
    chevronUp: "chevron-up",
    chevronRight: "chevron-right",
    chevronLeft: "chevron-left",
    calendarClock: "calendar-clock",
    calendar: "calendar",
    database: "database",
    finance: "finance",
    boxes: "boxes",
    trash: "trash",
    box: "box",
    archiveOutline: "archive-outline",
    settings: "settings",
    mapMarker: "map-marker",
    packageVariant: "package-variant",
    packageVariantClosed: "package-variant-closed",
    menu: "menu-outline",
    turnOff: "turn-off",
    plus:"plus",
    crossCircle: "cross-circle",
    fileShare: "file-share",
    attachment: "attachment",
    caretDown: "caret-down",
    circleMedium: "circle-medium",
    eye: "eye",
    eyeOff: "eye-off",
    cloudUpload: "cloud-upload",
    plusCircleOutline: "plus-circle-outline",
    checkCircle: "check-circle",
    information: "information",
    download: "download",
    documentOutline: "document-outline",
    magnifier: "magnifier",
    pencil: "pencil",
    ltr: "ltr",
    list: "list",
    fileTree: "file-tree",
    warehouse: "warehouse",
    home: "home",
    truck: "truck",
    minusCircle: "minus-circle",
    key: "key",
    cameraPlus: "camer-plus",
    tableArrowUp: "table-arrow-u",
    cashMultiple: "cash-multiple",
    refresh: "refresh",
    columnWidth: "column-width",
    rowHeight: "row-height",
    cubeOutline: "cube-outline",
    counter: "counter",
    accountPlus: "account-plus",
    informationOutline: "information-outline",
    ruller: "ruller",
    userKey: "user-key",
    printer: "print",
    lable: "lable",
    mailOutline: "mail-outline",
    mailUnread: "mail-unread-outline",
    mailOpen: "mail-open-outline",
    mailAnswered: "answered-mail",
    receipt: "receipt",
    callBlack: "call-black",
    page: "page",
    store: "store",
    tableColumn: "table-column",
    creditCard: "credit-card",
    plusMultiple: "plus-multiple",
    excelFile: "excel-file",
    appartment: "appartment",
    status: "status",
    conflict: "conflict",
    document: "document",
    listCheck: "list-check",
    userArrowRight: "user-arrow-right",
    badgePercent: "badge-percent",
    catalog: "catalog",
    gift:"gift",
    sticker: "sticker",
    visitCard: "visit-card",
    star: "star",
    addressBook: "address-book",
    boxArrowDown: "box-arrow-down",
    clipboard: "clipboard",
    invoice: "invoice",
    pallet: "pallet",
    stock: "stock"
}

function RonadIcons (props: {name:keyof typeof icons, title?: string, onClick?:(e: any) => void, className?: string, size?:number, style?: any }) {
    const {onClick,title,className,name, size} = props
    const fontSize = 24 * size
    const classes = `icon icon-${icons[name]} ${className} pointer`
    const style = {
        ...props.style,
        fontSize
    }

    return (
        <span className={classes} style={style} title={title} onClick={onClick}>
        </span>
    )
}

RonadIcons.defaultProps = {
    size: 1
}

export default RonadIcons;